import React, { useState } from "react";
import { destinationConnectors } from "./data";
import { Connector } from "../../../components/types";
import { useNavigate } from "react-router-dom";
import { SetupGuide } from "../../../components/marketing/connector/setup-guide";
import { ConnectorSelection } from "../../../components/marketing/connector/connector-seletion";

const DestinationsDashboard: React.FC = () => {
  const navigate = useNavigate();
  const [selectedDestination, setSelectedDestination] =
    useState<Connector | null>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showGuide, setShowGuide] = useState(false);
  const [selectedConnectorForGuide, setSelectedConnectorForGuide] =
    useState<Connector | null>(null);

  const filteredConnectors = destinationConnectors.filter((connector) => {
    return connector.name.toLowerCase().includes(searchTerm.toLowerCase());
  });

  const handleConfigure = (id: string) => {
   
  };

  function handleAddConnector() {
    navigate("/create/connections");
  }

  const handleCloseGuide = (): void => {
    setShowGuide(false);
    setSelectedConnectorForGuide(null);
  };

  const handleShowGuide = (connector: Connector): void => {
    setSelectedConnectorForGuide(connector);
    setShowGuide(true);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setSearchTerm(e.target.value);
  };

  return (
    <div className="min-h-screen my-5 bg-white flex">
      <div
        className={`transition-all duration-300 px-6 ${
          showGuide ? "w-1/2" : "w-full"
        }`}
      >
        {/* Header - Removed the duplicate search input */}
        <div className="flex justify-between items-center mb-6">
          <div className="flex items-center space-x-4">
            <h1 className="text-2xl font-semibold text-gray-900">
              Destinations
            </h1>
          </div>

          <button
            onClick={handleAddConnector}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700"
          >
            Add Destinations
          </button>
        </div>

        {/* Stats */}
        <div className="mb-6">
          <p className="text-gray-600">
            Available Destinations • {destinationConnectors.length}+ integrations
          </p>
        </div>

        {/* Using the reusable ConnectorSelection component */}
        <ConnectorSelection
          title="Select Destinations"
          description="Choose a data destination to connect from"
          connectors={filteredConnectors}
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          selectedConnector={selectedDestination}
          onSelectConnector={setSelectedDestination}
          onShowGuide={handleShowGuide}
          onConfigure={handleConfigure}
          placeholder="Search destinations..."
        />
      </div>

      {showGuide && selectedConnectorForGuide && (
        <div className="w-1/2 border-l border-gray-300">
          <SetupGuide
            connector={selectedConnectorForGuide}
            onClose={handleCloseGuide}
          />
        </div>
      )}
    </div>
  );
};

export default DestinationsDashboard;
